import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import I18n from 'i18n'
import { User } from 'graphqlAPI'
import { joinKeys } from 'helpers/translations.helper'
import { DropdownLoader } from 'components/ui/DropdownLoader'
import { DropdownButton, styles } from 'components/ui/DropdownButton'
import coursesReminder from 'api/administration/participants/coursesReminder'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import { useAccess } from 'contexts/AccessContext'
import { prefixTranslation } from './common'
import optionStyles from './Options.module.scss'

interface IProps {
  user: User
}

const Options: React.FC<IProps> = ({ user }) => {
  const { t } = useTranslation()
  const loading = false
  const [show, setShow] = useState(false)
  const { can, access } = useAccess()

  const { id, allCoursesProgress } = user
  const handleDropdownClick = (nextShow: boolean) => {
    setShow(nextShow)
  }

  const canViewProfile = access.canViewParticipantProfile()
  const canManageProgress = can('manageProgress')
  const canSendReminder =
    canManageProgress &&
    !!(allCoursesProgress?.pending || allCoursesProgress?.inProgress)

  const hasVisibleOptions =
    canViewProfile || (canManageProgress && canSendReminder)

  if (!hasVisibleOptions) {
    return null
  }

  return (
    <div
      className={show ? optionStyles.menuOpen : undefined}
      data-menu-open={show ? 'true' : undefined}
    >
      <DropdownButton
        show={show}
        disabled={loading}
        className={styles.actionSelect}
        alignRight
        title={<DropdownLoader loading={loading} />}
        onClick={() => handleDropdownClick(!show)}
        onToggle={(nextShow) => handleDropdownClick(nextShow)}
      >
        {canViewProfile && (
          <Link
            className={styles['option-item']}
            to={`/configuration/user-profile/${id}`}
            onClick={() => setShow(false)}
          >
            {t(joinKeys(prefixTranslation, 'view'))}
          </Link>
        )}
        {canManageProgress && (
          <a
            className={
              canSendReminder
                ? styles['option-item']
                : `${styles['option-item']} ${optionStyles.optionDisabled}`
            }
            onClick={async () => {
              if (!canSendReminder) return
              try {
                await coursesReminder(id)
                SuccessToast(
                  I18n.t('administration.toastMessages.coursesReminder')
                )
                setShow(false)
              } catch (e) {
                ErrorToast(
                  I18n.t('administration.toastMessages.coursesReminderError')
                )
              }
            }}
          >
            {t(joinKeys(prefixTranslation, 'sendReminder'))}
          </a>
        )}
      </DropdownButton>
    </div>
  )
}

export default Options
